export const getOrdersStatusFromStorage = (): string | null => localStorage.getItem('ordersStatus');
